const Loader = () => {
  return (
    <div className='flex justify-center align-center min-h-90'>
      <div className='loader'></div>
    </div>
  );
};
export default Loader;
